var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vbDenVTThuHoiIndex',{attrs:{"statusByVT":_vm.VB_INCOMING_DOC.STATUS_VANTHU.DA_XU_LY},on:{"viewDetail":_vm.viewDetail}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89e1e2be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/doc-in/vbDenThuHoiIndex.vue
// module id = TC7x
// module chunks = 89